import React, { useState, useEffect } from 'react';
import { Header, MenuItemOption } from '../common_v2/components/Header';
import { Footer } from '../common_v2/components/Footer';
import { useAuthentication } from '../Login/hooks/useAuthentication';
import { isMobileScreen } from '@apply/ui';
import { UserManagementSectionTabPanel } from './components/UserManagementSectionTabPanel/UserManagementSectionTabPanel';
import { ManageUserSectionDirections, Section } from './constants/ManageUserSectionDirections';
import { FeatureType } from '@apply/constants';
import { InviteUserButton } from './components/InviteUserButton/InviteUserButton';
import { useRefreshUserManagement } from './queries/userManagementQueries';

export const ManageUsers: React.FC = () => {
    const [selectedSection, set_selectedSection] = useState(Section.ByProperty);
    const [activeTab, set_activeTab] = useState(0);
    const mobileScreen = isMobileScreen();
    const handleRefresh = useRefreshUserManagement();

    const { authentication, isAuthenticated, isFeatureEnabled } = useAuthentication();

    useEffect(() => {
        if (!authentication) {
            return;
        }

        if (!isAuthenticated) {
            if (!window.location.pathname.startsWith('/login')) {
                window.location.href = '/login';
            }
        }
    }, [authentication, isAuthenticated]);

    useEffect(() => {
        switch (activeTab) {
            case 0:
                set_selectedSection(Section.ByProperty);
                return;
            case 1:
                set_selectedSection(Section.ByUser);
                return;
            default:
                set_selectedSection(Section.ByProperty);
                return;
        }
    }, [activeTab]);

    if (!isFeatureEnabled(FeatureType.GeneralContractor)) {
        window.location.href = '/home';
    }

    return (
        <>
            <div className='app-container'>
                <Header activeMenuItem={MenuItemOption.ManageUsers} />
                <main>
                    <div className='manageUsers'>
                        <div className='manageUsers-header'>
                            <div className={`manageUsers-header-title ${mobileScreen ? 'mobile' : ''}`}>
                                <h2>Manage Users</h2>
                                {!mobileScreen && (
                                    <div className='manageUsers-sectionDirections'>
                                        {ManageUserSectionDirections[selectedSection]}
                                    </div>
                                )}
                            </div>
                            <div className='manageUsers-header-action'>{!mobileScreen && <InviteUserButton onRefresh={handleRefresh} />}</div>
                        </div>
                        <div className='manageUsers-sectionTabPanel'>
                            <UserManagementSectionTabPanel
                                activeIndex={activeTab}
                                set_selectedTab={set_activeTab}
                            />
                        </div>
                    </div>
                </main>
            </div>
            <Footer />
        </>
    );
};
